<ion-header class="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span>
        </ion-item>
      </ion-list>
    </ion-buttons>
    <ion-title class="--logo">
      <a class="header__logo" [routerLink]="['/']">
        <app-logo></app-logo>
      </a>
      <span>Dashboard</span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-avatar class="header__avatar" [routerLink]="['..', routes.settings]">
        <img class="header__avatar__image" src="/assets/avatar/anna.svg" [alt]="(user$ | async)?.firstName" />
      </ion-avatar>
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="home">
  <app-challenge-layout *ngIf="actionButton$ | async; let actionButton">
    <div class="challenge__header" [appBackgroundImage]="actionButton.imageUrl">
      <div class="challenge__header__tag" [innerHTML]="'ACTION_BUTTON_MODAL.YOUR_CHALLENGE' | translate"></div>
      <h2 class="challenge__header__title" [innerHTML]="actionButton.title"></h2>
      <h5 class="challenge__header__text"></h5>
      <ion-button
        class="wow-button --white"
        [innerHTML]="(actionButton$ | async)?.actionText"
        (click)="handleActionButtonClick(actionButton)"
      ></ion-button>
    </div>
    <div class="challenge__content">
      <ng-container *ngIf="isMobileLikeView; else desktop">
        <app-news-feed></app-news-feed>
      </ng-container>

      <ng-template #desktop>
        <ion-content class="challenge__content__inner">
          <app-news-feed></app-news-feed>
        </ion-content>
      </ng-template>
    </div>
  </app-challenge-layout>
</ion-content>
